import { Component } from 'react';
import PropTypes from 'prop-types';
import { camelize } from '../utils/String';

export class Marker extends Component {
  componentDidMount() {
    this.renderMarker();
  }

  componentDidUpdate(prevProps) {
    if (this.props.map !== prevProps.map || this.props.position !== prevProps.position) {
      if (this.marker) {
        this.marker.setMap(null);
      }
      this.renderMarker();
    }
  }

  componentWillUnmount() {
    if (this.marker) {
      this.marker.setMap(null);
    }
  }

  handleEvent(evt) {
    return (e) => {
      const evtName = `on${camelize(evt)}`;
      if (this.props[evtName]) {
        this.props[evtName](this.props, this.marker, e);
      }
    };
  }

  renderMarker() {
    let position = this.props.position;
    const google = window.google;

    const { map, mapCenter, icon } = this.props;

    if (!google || !map) {
      return null;
    }

    const pos = position || mapCenter;

    if (!(pos instanceof google.maps.LatLng)) {
      position = new google.maps.LatLng(pos.lat, pos.lng);
    }

    const pref = {
      map,
      position,
      icon: new google.maps.MarkerImage(
        icon,
        new google.maps.Size(30, 40),
        new google.maps.Point(0, 0),
        new google.maps.Point(10, 30),
      ),
    };
    this.marker = new google.maps.Marker(pref);

    ['click', 'mouseover', 'recenter'].forEach((e) => {
      this.marker.addListener(e, this.handleEvent(e));
    });

    this.props.onAddMarker(this.marker);
    return null;
  }

  render() {
    return null;
  }
}

Marker.propTypes = {
  position: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  }),
  map: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  icon: PropTypes.string,
  mapCenter: PropTypes.number,
  onAddMarker: PropTypes.func,
  click: PropTypes.func,
  mouseover: PropTypes.func,
  recenter: PropTypes.func,
};

export default Marker;
